(ns manatee.ui.app-db)

(defn- ui-path
  [path]
  (conj [:ui] path))

(def view-path
  [:kee-frame/route :handler])

(def menu-open?-path
  (ui-path :menu-open?))

(defn get-view
  [db]
  (get-in db view-path))

(defn set-toggle-menu
  [db]
  (update-in db menu-open?-path not))

(defn get-menu-open?
  [db]
  (get-in db menu-open?-path))
